var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { saveAs } from 'file-saver';
import { TERMS_REQUEST, TERMS_SUCCESS, TERMS_FAILURE, TERM_LATEST_REQUEST, TERM_LATEST_SUCCESS, TERM_LATEST_FAILURE, POLICIES_REQUEST, POLICIES_SUCCESS, POLICIES_FAILURE, POLICY_LATEST_REQUEST, POLICY_LATEST_SUCCESS, POLICY_LATEST_FAILURE, REQUEST_DATA_FAILURE, REQUEST_DATA_REQUEST, REQUEST_DATA_SUCCESS, } from './constants';
import services from '../../services';
var PolicyService = services.PolicyService, TermService = services.TermService, UserService = services.UserService;
export var loadLatestTerm = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var latestTerm, e_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({
                    type: TERM_LATEST_REQUEST,
                });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, TermService.termLatest()];
            case 2:
                latestTerm = (_a.sent()).object;
                dispatch({
                    type: TERM_LATEST_SUCCESS,
                    latestTerm: latestTerm,
                });
                return [3 /*break*/, 4];
            case 3:
                e_1 = _a.sent();
                dispatch({
                    type: TERM_LATEST_FAILURE,
                });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var loadLatestPolicy = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var latestPolicy, e_2;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({
                    type: POLICY_LATEST_REQUEST,
                });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, PolicyService.policyLatest()];
            case 2:
                latestPolicy = (_a.sent()).object;
                dispatch({
                    type: POLICY_LATEST_SUCCESS,
                    latestPolicy: latestPolicy,
                });
                return [3 /*break*/, 4];
            case 3:
                e_2 = _a.sent();
                dispatch({
                    type: POLICY_LATEST_FAILURE,
                });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var loadTerms = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var terms, e_3;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                dispatch({
                    type: TERMS_REQUEST,
                });
                _a.label = 1;
            case 1:
                _a.trys.push([1, 3, , 4]);
                return [4 /*yield*/, TermService.termAll()];
            case 2:
                terms = (_a.sent()).objects;
                dispatch({
                    type: TERMS_SUCCESS,
                    terms: terms,
                });
                return [3 /*break*/, 4];
            case 3:
                e_3 = _a.sent();
                dispatch({
                    type: TERMS_FAILURE,
                });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/];
        }
    });
}); }; };
export var loadPolicies = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var policies, e_4;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 2, , 3]);
                dispatch({
                    type: POLICIES_REQUEST,
                });
                return [4 /*yield*/, PolicyService.policyAll()];
            case 1:
                policies = (_a.sent()).objects;
                dispatch({
                    type: POLICIES_SUCCESS,
                    policies: policies,
                });
                return [3 /*break*/, 3];
            case 2:
                e_4 = _a.sent();
                dispatch({
                    type: POLICIES_FAILURE,
                });
                return [3 /*break*/, 3];
            case 3: return [2 /*return*/];
        }
    });
}); }; };
export var sendDataRequest = function () { return function (dispatch) { return __awaiter(void 0, void 0, void 0, function () {
    var response, blob, err_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                _a.trys.push([0, 3, , 4]);
                dispatch({ type: REQUEST_DATA_REQUEST });
                return [4 /*yield*/, UserService.requestProfileInfo()];
            case 1:
                response = _a.sent();
                return [4 /*yield*/, response.blob()];
            case 2:
                blob = _a.sent();
                saveAs(blob, 'UserInformation.xlsx');
                dispatch({ type: REQUEST_DATA_SUCCESS });
                return [3 /*break*/, 4];
            case 3:
                err_1 = _a.sent();
                dispatch({
                    type: REQUEST_DATA_FAILURE,
                    err: 'Something went wrong while fetching Information, Please try again',
                });
                return [3 /*break*/, 4];
            case 4: return [2 /*return*/, null];
        }
    });
}); }; };
